import { Button, Input, Modal } from "antd";
import SucessImg from "assets/green_check.svg";
import { useState } from "react";

const { TextArea } = Input;

type ApproveModalProps = {
  open: boolean;
  onConfirm: (remark: string) => void;
  onCancel: () => void;
};

export const ApproveModal = ({
  open,
  onConfirm,
  onCancel,
}: ApproveModalProps) => {
  const [remark, setRemark] = useState("");

  const handleConfirm = () => {
    onConfirm(remark); // pass remark to parent
    setRemark(""); // reset after submit
  };

  return (
    <Modal open={open} footer={null} closable={false} centered width={420}>
      <div style={{ textAlign: "center", padding: "10px 0" }}>
        <img src={SucessImg} alt="" />

        <div
          style={{
            fontSize: "20px",
            fontWeight: 600,
            marginBottom: "10px",
          }}
        >
          Approve Request!
        </div>

        <div
          style={{
            color: "#555",
            fontSize: "14px",
            marginBottom: "20px",
          }}
        >
          Are you sure you want to approve <strong>All Selected</strong>{" "}
          withdrawal requests?
        </div>

        <div
          style={{
            fontSize: "14px",
            fontWeight: 500,
            marginBottom: "6px",
            textAlign: "left",
          }}
        >
          Remark
        </div>
        <TextArea
          placeholder="Enter remark (optional)"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          rows={3}
          style={{ marginBottom: "20px", borderRadius: "6px" }}
        />

        <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
          <Button
            onClick={() => {
              setRemark("");
              onCancel();
            }}
            style={{
              borderRadius: "6px",
              padding: "0 18px",
            }}
          >
            No
          </Button>

          <Button
            type="primary"
            onClick={handleConfirm}
            style={{
              backgroundColor: "#0a8f2f",
              borderColor: "#0a8f2f",
              borderRadius: "6px",
              padding: "0 18px",
            }}
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};
